"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _utils = require("../../utils");
const _excluded = ["color", "currencyCode", "amount", "size", "weight", "currencySize", "currencyWeight", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const defaultProps = {
  currencyCode: 'clp',
  amount: 0,
  currencySize: 12,
  currencyWeight: 500,
  className: ''
};
function Pricing(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      color,
      currencyCode,
      amount,
      size,
      weight,
      currencySize,
      currencyWeight,
      className
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  const isNegativeValue = (0, _react.useMemo)(() => amount < 0, [amount]);
  const formattedAmount = (0, _react.useMemo)(() => (0, _utils.formatCurrency)(amount, {
    currency: currencyCode
  }), [currencyCode, amount]);
  const [, currencySign, value] = (formattedAmount === null || formattedAmount === void 0 ? void 0 : formattedAmount.match(/^(\D*)(\d.*)$/)) || [];
  const fCurrencySign = (currencySign === null || currencySign === void 0 ? void 0 : currencySign.replace('-', '')) || '';
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    color: color,
    size: size,
    weight: weight,
    datasets: {
      type: 'price'
    }
  }, restOfProps, {
    afterStyles: {
      color,
      content: fCurrencySign,
      size: currencySize,
      weight: currencyWeight
    },
    className: className
  }), isNegativeValue ? "-".concat(value) : value || '$?');
}
var _default = exports.default = Pricing;